import React from 'react';
import './HeroSection.css';
import waterBackground from '../../assets/videos/water-background.mp4';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="video-wrapper">
        <video 
          src={waterBackground} 
          loop 
          autoPlay 
          muted 
          playsInline 
          className="background-video"
        />
        <div className="overlay"></div>
      </div>
      <div className="hero-content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="hero-headline">
                <p>Renovate. Innovate.</p>
                <p>Accelerate.</p>
              </h1>
              <div className="hero-subheading">
                <p>We invest in unlimited potential.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;